import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import api from 'api';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import useCallbackAsync from 'hooks/useCallbackAsync';
import EmptyState from 'assets/images/reports-empty-state.webp';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';

import './ShareableLinkHasExpired.styles.scss';

type ShareableLinkHasExpiredProps = {
  className?: string;
  shareableLinkId: string;
};

const ShareableLinkHasExpired: React.FC<ShareableLinkHasExpiredProps> = (
  props,
) => {
  const { className, shareableLinkId } = props;

  const [isRequestSent, setIsRequestSent] = useState(false);

  const classes = classNames('shareable-link-has-expired', className);

  const { popSuccess } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  const [requestAccess, isRequesting] = useCallbackAsync(async () => {
    await api.shareableLinks.requestAccessForExpiredLink(shareableLinkId);
    setIsRequestSent(true);
    popSuccess(t('weSentRequestToBroker'));
  });

  return (
    <ShareableLinkLockScreen
      title={t('shareableLinkHasExpired')}
      className={classes}
      image={EmptyState}
    >
      <Button disabled={isRequesting || isRequestSent} onClick={requestAccess}>
        {t('requestAccess')}
      </Button>
    </ShareableLinkLockScreen>
  );
};

export default ShareableLinkHasExpired;
